import { render, staticRenderFns } from "./Teleplay.vue?vue&type=template&id=553711c6&"
import script from "./Teleplay.vue?vue&type=script&lang=js&"
export * from "./Teleplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('553711c6')) {
      api.createRecord('553711c6', component.options)
    } else {
      api.reload('553711c6', component.options)
    }
    module.hot.accept("./Teleplay.vue?vue&type=template&id=553711c6&", function () {
      api.rerender('553711c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/detail/Teleplay.vue"
export default component.exports